import { Box, Circle, Cylinder, Crosshair, Triangle, Spline, Hexagon, CircleDot, Disc, Pill, Diamond, Gem, Layers, Trash2, FolderOpen, Save } from 'lucide-react';
import { useCadStore } from '../store/cadStore';
import { useThemeTokens } from '../theme';

/* Tinkercad-style RIGHT-SIDE shape library: a vertical grid of primitives you
   click to drop onto the central snap-grid. */
export default function ShapeLibraryPanel({ onAdd }) {
    const t = useThemeTokens();
    const savedShapes = useCadStore((s) => s.savedShapes);
    const loadShape = useCadStore((s) => s.loadShape);
    const deleteShape = useCadStore((s) => s.deleteShape);
    const SHAPES = [
        { type: 'cube', label: 'Cube', icon: Box },
        { type: 'sphere', label: 'Sphere', icon: Circle },
        { type: 'cylinder', label: 'Cylinder', icon: Cylinder },
        { type: 'cone', label: 'Cone', icon: Crosshair },
        { type: 'pyramid', label: 'Pyramid', icon: Triangle },
        { type: 'wedge', label: 'Wedge', icon: Spline },
        { type: 'prism', label: 'Prism', icon: Hexagon },
        { type: 'tube', label: 'Tube', icon: CircleDot },
        { type: 'torus', label: 'Torus', icon: Disc },
        { type: 'capsule', label: 'Capsule', icon: Pill },
        { type: 'diamond', label: 'Diamond', icon: Diamond },
        { type: 'gem', label: 'Gem', icon: Gem },
    ];
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, width: '100%', height: '100%' }}>
            <div style={{ fontSize: 11, color: t.textMuted, fontWeight: 700, letterSpacing: '0.06em' }}>Shape Library</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 7 }}>
                {SHAPES.map(({ type, label, icon: Icon }) => (
                    <button key={type} onClick={() => onAdd(type)} title={`Add ${label}`}
                        style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4,
                            padding: '11px 2px', background: t.surface, border: `1px solid ${t.borderLight}`,
                            borderRadius: 10, color: t.textSub, cursor: 'pointer', fontSize: 10, fontWeight: 600,
                        }}>
                        <Icon size={17} />{label}
                    </button>
                ))}
            </div>
            {savedShapes.length > 0 && (
                <div style={{ fontSize: 11, color: t.textMuted, fontWeight: 700 }}>My Shapes</div>
            )}
            {savedShapes.map((sh) => (
                <div key={sh.id} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <button onClick={() => loadShape(sh.id)} title={`Load ${sh.name}`}
                        style={{
                            flex: 1, display: 'flex', alignItems: 'center', gap: 7, padding: '7px 9px', textAlign: 'left',
                            background: t.surface, border: `1px solid ${t.borderLight}`, borderRadius: 9,
                            color: t.text, cursor: 'pointer', fontSize: 11.5, fontWeight: 600,
                        }}>
                        <FolderOpen size={13} color={t.accent} /> {sh.name}
                        <span style={{ marginLeft: 'auto', fontSize: 10, color: t.textMuted }}>{sh.parts.length}p</span>
                    </button>
                    <button onClick={() => deleteShape(sh.id)} title="Delete shape"
                        style={{ padding: 6, background: t.surface, border: `1px solid ${t.borderLight}`, borderRadius: 7, color: t.danger, cursor: 'pointer', display: 'flex' }}>
                        <Trash2 size={12} />
                    </button>
                </div>
            ))}
        </div>
    );
}